import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

// Reskin: quote-style text links (Amber's nav): 18px dark text with a 24px line icon, bark when selected, in a 72px header.
const styles = (theme) => ({
  root: {
    fontWeight: 300,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    padding: (smallPadding) => (smallPadding ? '' : '33px 0'),
    ...reskinStyles(theme, {
      fontSize: 18,
      fontWeight: 400,
      color: theme.colors.text_primary,
      minWidth: 0,
      minHeight: theme.sizes.headerHeight,
      padding: 0
    })
  },
  selected: {
    fontWeight: 600,
    color: theme.colors.header__label_primary,
    ...reskinStyles(theme, { fontWeight: 400, color: theme.colorPalette.orange_50 })
  },
  wrapper: {
    flexDirection: 'row',
    padding: (smallPadding) => (smallPadding ? '0 16px' : ''),
    ...reskinStyles(theme, { padding: theme.spacing(0, 4) })
  },
  smallIcon: {
    width: 20,
    height: 20,
    marginRight: theme.spacing(2),
    ...reskinStyles(theme, { display: 'none' })
  },
  largeIcon: {
    width: 30,
    height: 30,
    marginRight: theme.spacing(2),
    ...reskinStyles(theme, { display: 'none' })
  },
  reskinIcon: {
    flexShrink: 0,
    width: 24,
    height: 24,
    marginRight: theme.spacing(2)
  },
  label: {
    display: 'inline-block',
    whiteSpace: 'nowrap'
  }
});

export default makeStyles(styles);
